module.exports = __webpack_public_path__ + "static-m/img/tiwen.e031fc1d.png";